import type { PaymentSession, StartPaymentInput } from "../types/payment";
import type { StartPayResponse } from "../types/response";
import { normalizeResponse } from "../core/normalizeResponse";

export type PaymentAdapter = (session: PaymentSession, input: StartPaymentInput) => Promise<StartPayResponse>;

const inferStatus = (raw: Record<string, unknown>) => {
  const status = String(raw.status ?? raw.paymentStatus ?? "").toLowerCase();
  if (status === "success" || status === "paid" || status === "completed") return "success";
  if (status === "failed" || status === "failure") return "failed";
  if (status === "cancelled" || status === "canceled") return "cancelled";
  return "pending";
};

export const customGatewayAdapter: PaymentAdapter = async (session, input) => {
  const raw = {
    ...(typeof session.rawResponse === "object" && session.rawResponse ? session.rawResponse : {}),
    paymentId: session.paymentId,
    gateway: session.gateway,
    orderId: input.orderId
  };

  return normalizeResponse({
    status: inferStatus(raw) as "success" | "failed" | "pending" | "cancelled",
    input,
    rawResponse: raw
  });
};
